import React from 'react';

const style = {
  width: '24px',
  height: '24px',
  border: '1px solid black'
};

const Cell = ({children, filled = false, onClick}) => (
  <div
    onClick={onClick}
    style={{...style, backgroundColor: filled ? 'black' : null}}
  >
    {children}
  </div>
);

export default Cell;



/** WEBPACK FOOTER **
 ** ./components/Cell.js
 **/